let timer;
// console.log(timer);
const apiKey = 'AIzaSyBiAnEhGVTfT5iyx1asfdH4L0x-8VWKvsk';

export default {

  isAuthenticated(context, data) {
    context.commit('isAuthenticated', data);
  },
  uId(context, data) {
    context.commit('uId', data);
  },
  token(context, data) {
    context.commit('token', data);
  },

  today(context, data) {
    context.commit('today', data);
  },
  todayActual(context, data) {
    context.commit('todayActual', data);
  },
  tomorrowActual(context, data) {
    context.commit('tomorrowActual', data);
  },
  todaysDateDisplay(context, data) {
    context.commit('todaysDateDisplay', data);
  },
  dayOfWeek(context, data) {
    context.commit('dayOfWeek', data);
  },

  reasons(context, data) {
    context.commit('reasons', data);
  },
  program(context, data) {
    context.commit('program', data);
  },




  /**
   * am i using these? -- yes, but the way i'm using it is wrong. it should/shall be cleaned up later
   */
  async signup(context, data) {
    const response = await fetch(`https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=${apiKey}`, {
      method: 'POST',
      body: JSON.stringify({
        email: data.email,
        password: data.password,
        phone: data.phone,
        returnSecureToken: true,
      }),
    });
    const responseData = await response.json();

    if (!response.ok) {
      console.log(responseData);
      const error = new Error(responseData.message || 'Failed to authenticate');
      throw error;
    }

    console.log('actions/signup - response from API call', responseData);
    const expiresIn = +responseData.expiresIn * 1000;
    const expirationDate = new Date().getTime() + expiresIn;
    localStorage.setItem('uId', responseData.uId);
    localStorage.setItem('token', responseData.token);
    localStorage.setItem('tokenExpiration', expirationDate);
    timer = setTimeout(()=> {
      context.dispatch('autoSignout');
    }, expiresIn);
    context.commit('setUser', {
      token: responseData.idToken,
      uId: responseData.localId,
    });
  },

  async signout(context) {
    localStorage.removeItem('uId');
    localStorage.removeItem('token');
    localStorage.removeItem('tokenExpiration');

    clearTimeout(timer);
    context.commit('setUser', {
      uId: null,
      token: null,
    })

  },
  autoSignout(context) {
    context.dispatch('signout');
    context.commit('setAutoSignout');
  },


};
